import { SceneTransform } from 'redux/mode/reducers';
import styled from 'styled-components';

interface SceneProps {
	transform: SceneTransform;
}
export const Scene = styled.div<SceneProps>`
	height: 100%;
	width: 100%;
	position: absolute;
	overflow: visible;

	transform: scale(${(p) => p.transform.scale})
		translate(
			${(p) => p.transform.offset.x / p.transform.scale}px,
			${(p) => p.transform.offset.y / p.transform.scale}px
		);
	transform-origin: top left;
`;

interface BaseProps {
	color: string;
}
export const Base = styled.div<BaseProps>`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: ${(p) => p.color};
`;
